import { ApolloClient, NormalizedCacheObject, InMemoryCache } from "@apollo/client";

export const Client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  uri: "/api/graphql",
  cache: new InMemoryCache()
});